import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      overflow: 'hidden',
      flexDirection: 'column',
    },
    list: {
      minHeight: 48,
      flex: 1,
      minWidth: 0,
    },
    fieldMaxChars: {
      width: 180,
      flexShrink: 0,
    },
    formulaWrapper: {
      padding: theme.spacing(0),
    },
    divider: {
      margin: theme.spacing(3, 0),
      backgroundColor: COLORS.gray.gray60,
    },
    maxCharsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      flex: 1,
      alignItems: 'center',
    },
    error: {
      marginTop: theme.spacing(3),
    },
  }),
  { name: 'BlockCustomFormula' }
);
